import { Material } from '@core/model/Material.model';
import { ProdWarning } from './prodWarning.model';
import { DimensionModel } from '@core/model/dimension.model';
import { SeparadorInfo } from './separadorInfo.model';
import { LuzCapaInfo } from './LuzCapaInfo.model';
import { PrefaReglasInfo } from './prefaReglasinfo.model';
import { VilaxInfo } from './vilaxInfo.model';
import { GlassInfo } from './glassInfo.model';
import { ConfigService } from '@core/model/configService.model';
import { GlassService } from '@core/model/glassService.model';

export class model6030Info extends PrefaReglasInfo {
    vContramarco: boolean;
    vGuarnicion: boolean;
    constructor() {
    super();
    this.vModelo = '6030';
    this.vCodArticulo = '0600101';
    this.vCantidad = 1;
    this.vContramarco = true;
    this.vGuarnicion = false;
    this.vManipulaCerradura = 'INTERNA';
    this.vTieneReglas = true;
    }

    redimensionarModelo() {
        let vVilaxInfo: VilaxInfo;
        let vGlassInfo: GlassInfo;

        if (this.vListaLuzCapa.length > 0) {
            this.vListaLuzCapa.forEach(CapaTmp => {
                CapaTmp.vAncho1 = this.vAncho1;
                CapaTmp.vAlto1 = this.vAlto1;
                CapaTmp.vAncho2 = 0;
                CapaTmp.vAlto2 = 0;
                if (CapaTmp.vModelo !== undefined) {
                    if (CapaTmp.vModelo.vModelo === 'VIDRIO CORTADO') {
                        let vModeloTmp = CapaTmp.vModelo as GlassInfo;
                        vGlassInfo = new GlassInfo();
                        vGlassInfo.vAncho1 = this.vAncho1;
                        vGlassInfo.vAlto1 = this.vAlto1;
                        vModeloTmp.vAncho1 = this.vAncho1;
                        vModeloTmp.vAlto1 = this.vAlto1;
                        vGlassInfo.vListaServicios = vModeloTmp.vListaServicios;
                        vGlassInfo.redimensionarModelo();
                        vModeloTmp.vListaServicios = vGlassInfo.vListaServicios;
                    }
                }
            });
        }
    }
}
